/*       */

import { gql } from '@apollo/client';

export default gql`
    mutation eventToEventRelationRemoveMutation($event: EventReferenceInput!, $relatedEvent: EventReferenceInput!, $relationDefinition: ID!) {
        payload: eventRelationRemove(event: $event, relatedEvent: $relatedEvent, relationDefinition: $relationDefinition)
    }
`;
